module.exports = __webpack_public_path__ + "static/media/turnover1.fa1f9325.png";